import { RefAttributes, forwardRef } from 'react';
import {
  FormikTextField,
  FormikTextFieldProps,
} from '@krakentech/coral-formik';

import { piiDataAttributes } from '@/components/PII/constants';

/**
 * Uses forwardRef to maintain the ref chain from FieldArrayInner through to FormikTextField.
 * While forwardRef is being deprecated in React 19+, it's still the correct approach for React 18.2.0
 * and is necessary for proper ref forwarding in our component chain.
 */
const PIIFormikTextField = forwardRef<
  HTMLInputElement,
  FormikTextFieldProps & RefAttributes<HTMLInputElement>
>((props, ref) => {
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    // Call onFocus from props if it exists
    if (props.onFocus) {
      props.onFocus(e);
    }

    if (props.type === 'number') {
      const preventScroll = (event: WheelEvent) => event.preventDefault();
      e.target.addEventListener('wheel', preventScroll, { passive: false });

      // Cleanup on blur
      e.target.addEventListener(
        'blur',
        () => {
          e.target.removeEventListener('wheel', preventScroll);
        },
        { once: true }
      );
    }
  };

  return (
    <FormikTextField
      {...props}
      ref={ref}
      attributes={{
        ...props.attributes,
        ...piiDataAttributes,
      }}
      onFocus={handleFocus}
    />
  );
});

PIIFormikTextField.displayName = 'PIIFormikTextField';

export default PIIFormikTextField;
